import { Link, NavLink } from "react-router-dom";
import { Show, SignInButton, UserButton } from "@clerk/react";
import { Star, ShieldCheck, Bot } from "lucide-react";
import { useMember } from "@/components/MemberProvider";

const navCls = ({ isActive }) =>
  `px-2 sm:px-3 py-2 rounded-full text-xs sm:text-sm font-medium transition-colors ${isActive ? "bg-blue-600 text-white" : "text-slate-300 hover:text-white hover:bg-white/5"}`;

export const Header = () => {
  const { isAdmin } = useMember();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0B101D]/80 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center gap-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 mr-auto">
          <img src="/logo-horse.png" alt="The Weekend Edge" className="h-10 w-auto rounded-md" />
          <span className="hidden sm:inline font-display font-black italic uppercase text-lg tracking-tight leading-none">
            <span className="text-slate-300 text-[10px] sm:text-xs not-italic tracking-[0.3em] block">The</span>
            Weekend <span className="text-[#1E90FF]">Edge</span>
          </span>
        </Link>
        <nav className="flex items-center gap-0.5 sm:gap-1">
          <NavLink to="/tips" className={navCls} data-testid="nav-tips">Tips</NavLink>
          <NavLink to="/" end className={navCls} data-testid="nav-meetings">Meetings</NavLink>
          <NavLink to="/record" className={navCls} data-testid="nav-record">Results</NavLink>
          <Show when="signed-in">
            <NavLink to="/favourites" className={navCls} data-testid="nav-favourites">
              <Star className="w-4 h-4 inline sm:mr-1" /><span className="hidden sm:inline">Favourites</span>
            </NavLink>
          </Show>
          {isAdmin && (
            <NavLink to="/bot" className={navCls} data-testid="nav-bot">
              <Bot className="w-4 h-4 inline sm:mr-1" /><span className="hidden sm:inline">AI Bot</span>
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/admin" className={navCls} data-testid="nav-admin">
              <ShieldCheck className="w-4 h-4 inline sm:mr-1" /><span className="hidden sm:inline">Admin</span>
            </NavLink>
          )}
        </nav>
        <Show when="signed-out">
          <SignInButton>
            <button data-testid="google-signin-button" className="whitespace-nowrap px-4 py-2 rounded-full bg-blue-600 hover:bg-blue-500 text-sm font-semibold transition-colors">
              Sign in
            </button>
          </SignInButton>
        </Show>
        <Show when="signed-in"><div data-testid="user-menu"><UserButton /></div></Show>
      </div>
      <div className="finish-line" />
    </header>
  );
};
